import { useEffect } from "react";

const loaded = new Set();

export function useGoogleFont(fonts = []) {
  useEffect(() => {
    fonts
      .filter(Boolean)
      .forEach((f) => {
        const family = f.trim();
        if (!family || loaded.has(family)) return;
        loaded.add(family);
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `https://fonts.googleapis.com/css2?family=${family.replace(/ /g, "+")}:wght@400;500;600;700;800&display=swap`;
        document.head.appendChild(link);
      });
  }, [fonts.join("|")]); // eslint-disable-line
}
